<bai-client-info [session]="data" [showGuid]="true"></bai-client-info>
